module.exports = __webpack_public_path__ + "static/media/notification.a99e805b.svg";